import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';

import { AlertcLinear, VildData } from 'app/models';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';
import { LinearVildComponent } from 'app/shared/vild/linear/linear-vild.component';

@Component({
  selector: 'linear-details-vild',
  templateUrl: './linear-details-vild.component.html',
  styleUrls: ['./linear-details-vild.component.scss']
})
export class LinearDetailsVildComponent implements OnInit {
  @Input() id: string;
  @Input() label: string;
  @Input() readonly: boolean;
  @Input() inputStyle: CbmInputStyle;
  @Input() alertcLinears: AlertcLinear[];
  @Input() type: string;

  @Output() changeAlertc: EventEmitter<AlertcLinear[]> = new EventEmitter<AlertcLinear[]>();

  @ViewChildren(LinearVildComponent) vildComponents: QueryList<LinearVildComponent>;

  public collapsed: boolean;

  constructor() {}

  ngOnInit(): void {
    this.collapsed = false;
    this.sortAlertcLinears();
  }

  private sortAlertcLinears(): void {
    this.alertcLinears.sort((alertcA, alertcB) => {
      const indexA = alertcA.alertcIndex;
      const indexB = alertcB.alertcIndex;
      return indexA < indexB ? -1 : indexA > indexB ? 1 : 0;
    });
  }

  public collapseAll(): void {
    this.collapsed = !this.collapsed;
    this.vildComponents.forEach(vc => vc.collapse(this.collapsed));
  }

  public exportLinearsVildComponent(): AlertcLinear[] {
    const newAlertcLinears = [];
    this.vildComponents.forEach(vc => newAlertcLinears.push(vc.getAlerttcLinear()));
    return newAlertcLinears;
  }

  public onDeleteVildSegment(index: number): void {
    this.alertcLinears.splice(index - 1, 1);
    this.setAlertcIndexes();
    this.changeAlertc.emit(this.alertcLinears);
  }

  public onAddVildSegment(index: number): void {
    const newAlertc = new AlertcLinear();
    newAlertc.primaryVildLocation = new VildData();
    newAlertc.secondaryVildLocation = new VildData();
    newAlertc.vildVersion = this.alertcLinears[index].vildVersion;

    this.alertcLinears.splice(index, 0, newAlertc);
    this.setAlertcIndexes();
    this.changeAlertc.emit(this.alertcLinears);
  }

  private setAlertcIndexes(): void {
    for (let i = 0; i < this.alertcLinears.length; i++) {
      this.alertcLinears[i].alertcIndex = i + 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/linear-details/vild/linear-details-vild.component.ts